import { render, staticRenderFns } from "./ClinicCheckout.vue?vue&type=template&id=5bc82b68&scoped=true&"
import script from "./ClinicCheckout.vue?vue&type=script&lang=js&"
export * from "./ClinicCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc82b68",
  null
  
)

export default component.exports